import React from 'react'

const Buildings = () => {
  return (
    <div>Buildings</div>
  )
}

export default Buildings